module.exports = __webpack_public_path__ + "802482fe988d38570319bd4d74ea198f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/leo-selfie.jpg
 ** module id = 383
 ** module chunks = 0
 **/